/* eslint-disable  */
import {
    FormControlLabel,
    Switch
  } from "@material-ui/core";
  import { debounce } from "lodash";
  import * as moment from "moment";
  import React, { useEffect, useState } from "react";
  import ReactPaginate from "react-paginate";
  import { useDispatch, useSelector } from "react-redux";
  import { useHistory } from "react-router-dom";
  import { bindActionCreators } from "redux";
  import { format } from "timeago.js";
  import Loader from "../../Components/Loader";
  import NotFoundComponent from "../../Components/NotFoundComponent";
  import { dataActionCreators } from "../../services/Actions";
  import RenderAdminPage from "../RenderAdminPage";
  
    function LoanArchive() {
      const history = useHistory();
    const dispatch = useDispatch();
    const { GetAppliedLoans,GetArchievedLoans } = bindActionCreators(dataActionCreators, dispatch);
    const [checkSouthLoan, setCheckSouthLoan] = useState(false);
    const [checkNorthLoan, setCheckNorthLoan] = useState(false);
    const [search, setSearch] = useState(null);
    const [limit, setLimit] = useState(5);
    const data = useSelector((state) => state?.data);
    const status = "initiated"
   
  
    const [currentItems, setCurrentItems] = useState(null);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const itemsPerPage = limit;
    const [currentPage, setCurrentPage] = useState(0);
  
    const { appliedLoans, paginate, isLoading } = data;
  
    useEffect(() => {
      // Fetch items from another resources.
      const endOffset = itemOffset + itemsPerPage;
  
      console.log(`Loading items from ${itemOffset} to ${endOffset}`);
      setCurrentItems(appliedLoans?.slice(itemOffset, endOffset));
      setPageCount(Number(paginate?.total));
    }, [itemOffset, itemsPerPage, appliedLoans]);
  
    // Invoke when user click to request another page.
    const handlePageClick = (event) => {
      console.log("event", event);
      GetAppliedLoans(true, event.selected + 1, limit, status);
  
      console.log("currentPage", currentPage);
  
      const newOffset = (event.selected * itemsPerPage) % paginate?.total;
  
      setItemOffset(newOffset);
    };
  
    const handleSouthChange = (e) => {
      setCheckSouthLoan(e.target.checked);
    };
    const handleNorthChange = (e) => {
      setCheckNorthLoan(e.target.checked);
    };
  
    const onSearchTextChange = debounce((e) => {
      if (e?.target?.value) {
        setSearch(e?.target?.value ?? null);
        GetAppliedLoans(
          true,
          1,
          limit,
          status,
          `${e?.target?.value ? "&search=" + e?.target?.value : ""}`
        );
        // GetAllFunds(true, 1, limit, `${e?.target?.value ? "&search=" + e?.target?.value : ""}`)
      } else {
        setSearch(null);
        GetAppliedLoans(true, 1, limit, status);
      }
    }, 800);
    const Northern = checkNorthLoan && "Northern";
    const Southern = checkSouthLoan && "Southern";
  
  
  
    useEffect(() => {
      GetArchievedLoans(true, 1, limit);
      setCheckNorthLoan(false);
      setCheckSouthLoan(false);
    }, []);
  
    // useEffect(() => {
    //   if (Northern && Southern) {
    //     GetAppliedLoans(true, 1, limit, status);
    //   } else if (Northern) {
    //     GetAppliedLoans(
    //       true,
    //       1,
    //       limit,
    //       status,
    //       `${Northern ? "&filter=" + "Northern" : ""}`
    //     );
    //   } else if (Southern) {
    //     GetAppliedLoans(
    //       true,
    //       1,
    //       limit,
    //       status,
    //       `${Southern ? "&filter=" + "Southern" : ""}`
    //     );
    //   } else {
    //     GetAppliedLoans(true, 1, limit, status);
    //   }
  
    // }, [Southern, Northern]);
  
    // useEffect(() => {
    //   GetAppliedLoans(
    //     true,
    //     1,
    //     limit,
    //     status,
    //     `${Northern ? "&filter=" + "Northern" : ""}`
    //   );

    // }, [Northern]);
  
    return (
      <div>
        <RenderAdminPage title="Archives">
          {isLoading && <Loader />}

          <div className="flex flex-col sm:flex-row gap-3 mb-6">
            <div className="flex-1">
              <label htmlFor="search" className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">Search</label>
              <input
                type="search"
                id="search"
                placeholder="Search by staff ID, name..."
                className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-slate-800 dark:text-slate-200 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all placeholder:text-slate-400"
                onChange={onSearchTextChange}
              />
            </div>
            <div className="w-full sm:w-40">
              <label htmlFor="limit" className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">Show</label>
              <select
                className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-slate-800 dark:text-slate-200 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all"
                onChange={(e) => setLimit(e.target.value)}
              >
                <option value={15}>15</option>
                <option value={25}>25</option>
                <option value={30}>30</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={200}>200</option>
                <option value={300}>300</option>
              </select>
            </div>
          </div>

          {appliedLoans?.length > 0 ? (
            <>
              <div className="flex justify-between items-center mb-4">
                <p className="text-sm text-slate-500 dark:text-slate-400">{appliedLoans?.length || 0} records</p>
              </div>

              <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-slate-200 dark:border-gray-700 overflow-hidden">
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <thead>
                      <tr className="bg-slate-50 dark:bg-gray-700/50">
                        <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Name</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Loan Amount</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Mandate Number</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Date</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Sector</th>
                        <th className="px-4 py-3"></th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100 dark:divide-gray-700">
                      {appliedLoans.map((loan, index) => (
                        <tr key={index + 1} className="hover:bg-slate-50 dark:hover:bg-gray-700/30 transition-colors">
                          <td className="px-4 py-3">
                            <div className="flex items-center gap-3">
                              <img className="w-9 h-9 rounded-full object-cover" src={loan?.user?.profile_image || (loan?.user?.name?.split(" ")[0] === "Mr." ? "/images/dev/avarta2.jpeg" : "/images/dev/woman-avarta.jpeg")} alt="" />
                              <div>
                                <p className="text-sm font-medium text-slate-800 dark:text-slate-200">{loan?.user?.name}</p>
                                <p className="text-xs text-slate-500 dark:text-slate-400 font-semibold">{loan?.staff_id}</p>
                              </div>
                            </div>
                          </td>
                          <td className="px-4 py-3">
                            <p className="text-sm text-slate-700 dark:text-slate-300">&#8373;{loan?.loanAmount}</p>
                            <p className="text-xs text-slate-500 dark:text-slate-400">MD: {loan?.monthlyDeduction}</p>
                          </td>
                          <td className="px-4 py-3 text-sm text-slate-700 dark:text-slate-300">{loan?.mandateNumber}</td>
                          <td className="px-4 py-3">
                            <p className="text-sm text-slate-700 dark:text-slate-300">{moment(loan?.created_at).format("MMMM Do YYYY")}</p>
                            <p className="text-xs text-slate-500 dark:text-slate-400">{format(loan?.created_at)}</p>
                          </td>
                          <td className="px-4 py-3">
                            <span className={`inline-flex px-2.5 py-1 rounded-full text-xs font-semibold ${loan?.sector === "Northern" ? "bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300" : "bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300"}`}>
                              {loan?.sector}
                            </span>
                          </td>
                          <td className="px-4 py-3 text-right">
                            <button
                              type="button"
                              onClick={() => history.push({ pathname: "/admin/archieveloans-detailed", state: { loan } })}
                              className="text-slate-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
                            >
                              <svg className="h-5 w-5 fill-current" viewBox="0 0 24 24"><path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" /></svg>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {appliedLoans.length > 0 && (
                <ReactPaginate
                  breakLabel="..."
                  nextLabel=">"
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={5}
                  pageCount={pageCount}
                  previousLabel="<"
                  renderOnZeroPageCount={null}
                  containerClassName="pagination"
                  pageLinkClassName="page-num"
                  previousLinkClassName="page-num"
                  nextLinkClassName="page-num"
                  activeLinkClassName="active"
                />
              )}
            </>
          ) : (
            <NotFoundComponent title={"No archived loans at the moment"} />
          )}
        </RenderAdminPage>
      </div>
    );
    }
    
    export default LoanArchive;
     
